require('./score-card-detail.jade')
require('./templates/fairway.jade')
require('./templates/ob.jade')
require('./templates/putt.jade')
require('./templates/sand.jade')
require('./templates/shot.jade')
require('./templates/tee-off-club.jade')
require('./templates/water.jade')
_ = require("lodash")

ScoreCardDetailDirective = ($filter, ScoreCardUIService)->
  restrict: "A"
  replace: false
  templateUrl: "components/score-card/score-card-detail.jade"
  scope:
    holes: '=scoreCardHoles'
    player: '=scoreCardPlayer'
    editMode: '='
  link: (scope) ->
    scope.defaultData = ScoreCardUIService.getDefaultData()

    scope.boardTypeTitle = switch scope.boardType
      when 'in' then $filter("translate")("_SCORE_CARD_BOARD.IN")
      when 'out' then $filter("translate")("_SCORE_CARD_BOARD.OUT")

    scope.getTotal = (key) ->
      _.chain scope.player.scores
        .map (s) -> s[key] || 0
        .reduce (sum, val) -> sum + val
        .value()

    scope.getTotalPutt = ->
      _.chain scope.player.scores
        .map (s) -> s.putt_cnt || 0
        .reduce (sum, val) ->
          sum + (if val is ScoreCardUIService.PUTT_DISABLED_VALUE then 0 else val)
        , 0
        .value()

    scope.getTotalFairway = ->
      result = _.chain scope.player.scores
        .map (s) ->
          return if s.holePar == 3
          s.fairway
        .reduce (result, val) ->
          ++result.denominator if val
          ++result.numerator if val is 'center'
          result
        , {denominator: 0, numerator: 0}
        .value()
      return 0 if result.numerator is 0
      ((result.numerator / result.denominator) * 100)

    scope.getTotalParOn = ->
      result = _.chain scope.player.scores
        .reduce (result, score) ->
          ++result.denominator if score.shot_cnt and not score.putt_disabled
          ++result.numerator if score.is_par_on
          result
        , {denominator: 0, numerator: 0}
        .value()
      return 0 if result.numerator is 0
      ((result.numerator / result.denominator) * 100)

    scope.getTotalSandShot = ->
      _.chain scope.player.scores
        .map (s) -> s.sand_shot
        .reduce (sum, val) ->
          sum + (if val then 1 else 0)
        , 0
        .value()

    scope.getFairwayCssClass = (fairway) ->
      return "" if scope.editMode
      switch fairway
        when "center" then "circle-red"
        when "left" then "arrow-back"
        when "right" then "arrow-forward"

    scope.valueUpdated = (score, type) ->
      if type is 'shot_cnt'
        ScoreCardUIService.updateShotCntInfo(score)
      else if type is 'putt_cnt'
        ScoreCardUIService.updatePuttInfo(score)

    scope.isShotEntered = (score) ->
      return true if score?.shot_cnt

    scope.allowEnterFairwayHit = (score) ->
      score.holePar isnt ScoreCardUIService.PAR_VALUE_FOR_DISABLE_FAIRWAY

    scope.$watch (-> scope.player), ->
      return unless scope.player

      # add scoreOptions for scores
      _.forEach scope.player.scores, (score, index) ->
        # holePar will be used in calculating isParOn
        score.holePar = scope.holes[index].par
        score.putt_cnt = ScoreCardUIService.PUTT_DISABLED_VALUE if score.putt_disabled
        score.scoreOptions = ScoreCardUIService.getScoreOptions(score.holePar)
        ScoreCardUIService.updateShotCntInfo(score)
        return

ScoreCardDetailDirective.$inject = [
  "$filter"
  "ScoreCardUIService"
]

module.exports = ScoreCardDetailDirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/score-card/score-card-detail-directive.coffee